<!--
 * @Description:线索审核
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-03-14 09:46:48
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        @mask="showMask"
        rowKey="recordId"
        :row-selection="{ onChange: onSelectRowsChange, getCheckboxProps: getCheckboxProps }"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosOFbuApprovalClue"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="auditStatus" :label="t('operate.moulyj')">
              <a-radio-group
                v-model:value="queryForm.auditStatus"
                optionType="button"
                @change="search"
                :options="[{ label: t('common.all'), value: undefined }, ...applyStateEnum]"
              />
            </dc-form-item>
            <dc-form-item :label="t('operate.r1nt24')">
              <a-input v-model:value="queryForm.customerName" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item name="contactName" :label="t('operate.gal9fo')">
              <a-input v-model:value="queryForm.contact.name" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('operate.3eogpd')">
              <a-input v-model:value="queryForm.contact.keyword" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item name="applicant" :label="t('operate.6ihqzi')">
              <user-select v-model:value="queryForm.applicant" />
            </dc-form-item>
            <dc-form-item :label="t('operate.comzhy')">
              <cos-range-picker v-model:startTime="queryForm.startApplyTime" v-model:endTime="queryForm.endApplyTime" />
            </dc-form-item>
            <dc-form-item name="auditor" :label="t('operate.aayuli')">
              <user-select v-model:value="queryForm.auditor" />
            </dc-form-item>
            <dc-form-item :label="t('operate.5n66zv')">
              <cos-range-picker v-model:startTime="queryForm.startAuditTime" v-model:endTime="queryForm.endAuditTime" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'auditStatus'">
            <dc-status :enums="stateColorEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_ofbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button
                type="link"
                v-if="record.auditStatus === 1"
                v-permission="'ofbu_cluesaudit_check_btn'"
                @click="handleAppaly(record)"
                >{{ t('btn.review') }}</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAppaly()" v-permission="'ofbu_cluesaudit_check_btn'">{{
            t('btn.batchReview')
          }}</a-button>
        </template>
      </cos-table>
      <!---审核弹框--->
      <applyModel ref="applyModelRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { clueAuditList, salesClueDetail } from '@/api/overseasSales/clueManage'
import { clueTypeEnum } from '@/views/overseasSales/clueManage/dataConfig'
import applyModel from './applyModel.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import type { SalesClueListItem } from '@/typings/api/clueManage'

const { t } = useI18n()

const tableRef = ref()
const selectedRows = ref<SalesClueListItem[]>([])
const queryForm = ref({
  auditStatus: 1,
  contact: {
    type: 1
  }
})
const applyModelRef = ref()
const applyStateEnum = computed(() => [
  { label: t('operate.sukg7w'), value: 1 },
  { label: t('operate.cfq4cr'), value: 2 },
  { label: t('operate.fvmvfe'), value: 3 }
])
const stateColorEnum = computed(() => [
  {
    name: t('operate.sukg7w'),
    value: 1,
    color: '#1d4cd2'
  },
  {
    name: t('operate.cfq4cr'),
    value: 2,
    color: '#3FAC46'
  },
  {
    name: t('operate.fvmvfe'),
    value: 3,
    color: '#DF443B'
  }
])
const fetch = (params: object, callBack: (res: any) => void) => {
  clueAuditList({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: SalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack({
      contactName: contact.name,
      contactMobile: contact.mobile
    })
  })
}
const onSelectRowsChange = (keys: string[], rows: SalesClueListItem[]) => {
  selectedRows.value = rows
}
// 待审核&&当前
const getCheckboxProps = (record: SalesClueListItem) => ({
  disabled: !(record.auditStatus === 1), // Column configuration not to be checked
  auditStatus: record.auditStatus
})

const success = () => {
  tableRef.value.fetch()
}
const search = () => {
  tableRef.value.fetch()
}
const handleAppaly = (row?: SalesClueListItem) => {
  let data: any = []
  if (row && row.clueId) {
    data.push(row)
  } else {
    data = selectedRows.value
  }
  applyModelRef.value.toggle(data)
}
const columns = computed(() => [
  {
    title: t('operate.r1nt24'),
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/ofbu/salesClue/view',
    query: ['clueId', 'recordId', 'isApplay=1'],
    fixed: 'left'
  },
  {
    title: t('operate.6ihqzi'),
    dataIndex: 'createByName'
  },
  {
    title: t('operate.comzhy'),
    dataIndex: 'applyTime'
  },
  {
    title: t('operate.42ahj4'),
    dataIndex: 'applyReason'
  },
  {
    title: t('operate.aayuli'),
    dataIndex: 'auditorName'
  },
  {
    title: t('operate.5n66zv'),
    dataIndex: 'auditTime',
    width: 150
  },
  {
    title: t('operate.moulyj'),
    dataIndex: 'auditStatus'
  },
  {
    title: t('operate.gal9fo'),
    dataIndex: 'contactName',
    cosType: 'mask'
  },
  {
    title: t('operate.3eogpd'),
    dataIndex: 'contactMobile',
    cosType: 'mask'
  },
  {
    title: t('operate.mzmxr7'),
    dataIndex: 'customerRegion'
  },
  {
    title: t('operate.1lpu94'),
    dataIndex: 'clueType',
    dicData: clueTypeEnum
  },
  {
    title: t('operate.s0owdr'),
    dataIndex: 'beforeFollowerName'
  },
  {
    title: t('operate.ihxkbd'),
    width: 150,
    dataIndex: 'clueCreateTime'
  },
  {
    title: t('common.action'),
    dataIndex: 'action',
    width: 100,
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosOFbuCluesAudit' }
</script>
